export const enum YesNo {
  Yes = 'Yes',
  No = 'No',
}
